const partners: readonly Partner[] = [
  {
    name: 'Adorama',
    url: 'https://www.adorama.com/shootwithme',
    imageUrl: require('@/assets/partners/adorama.png'),
    description:
      'Adorama is one of the industry’s leading equipment suppliers. Use our exclusive partner link to get incredible discounts on all of your photography gear purchases.',
  },
  {
    name: 'Aftershoot',
    url: 'https://aftershoot.com?via=shootwithme',
    imageUrl: require('@/assets/partners/aftershoot.png'),
    description:
      'Aftershoot saves photographers countless hours in the culling process by using AI and your preferences to narrow down the best images! Signup today and get 15% off your first purchase!',
    couponCode: 'SHOOTWITHME15',
  },
  {
    name: 'CloudSpot',
    url: 'https://cloudspot.io/?af2=_febqZkyq3kT',
    imageUrl: require('@/assets/partners/cloudspot.png'),
    description:
      'CloudSpot is the easiest way for photographers to deliver and sell photos online through Galleries, Client Mobile Apps, Storefronts, and more! Grab 20% off your first 12 months with CloudSpot with this link. After you make a free account, the 20% will automatically be applied when you are ready to upgrade!',
  },
  {
    name: 'Imagen',
    url: 'https://imagen-ai.com/start?ref=shootwithme',
    imageUrl: require('@/assets/partners/imagen.png'),
    description:
      'Your personalised photo editing assistant. The fastest, most accurate AI editing desktop app for Lightroom workflows. ShootWith.Me users get 1500 free edits when they sign up!',
  },
  {
    name: 'TheLawTog',
    url: 'https://thelawtogshop.com/?sca_ref=1650534.E6byM8bSaU',
    imageUrl: require('@/assets/partners/thelawtog.png'),
    description: [
      'The LawTog is the #1 contract resource for professional photographers.',
      'Use the link and coupon code below to get 15% off your entire order.',
    ],
    couponCode: 'SHOOTWITHME',
  },
  {
    name: 'Swift Galleries',
    url: 'https://swiftgalleries.com/try',
    imageUrl: require('@/assets/partners/swiftgalleries.png'),
    description:
      'Swift Galleries is a web-based wall art design and in-person sales tool for professional wedding and portrait photographers.',
    couponCode: 'shootwithme',
    couponCodeDescription: 'for 15% off for life.',
  },
  {
    name: 'SLR Lounge',
    url: 'https://www.slrloungeworkshops.com/offers/opSMDrC5?coupon_code=SHOOTWITHME',
    imageUrl: require('@/assets/partners/slrlounge.png'),
    description: [
      'SLR Lounge Premium is the best way to level up your wedding photography, with training by Pye Jirsa on Posing, Flash, Photo Editing, Marketing, Sales and much more. This real-world, step-by-step training is the operating manual for running a successful wedding photography studio.',
      'Use the link and the coupon code below to get $50 off an annual SLR Lounge Premium Membership.',
    ],
    couponCode: 'SHOOTWITHME',
  },
  {
    name: 'StoryBook Design Co',
    url: 'https://StoryBookDesign.Co',
    imageUrl: require('@/assets/partners/storybookdesign.png'),
    description: [
      'StoryBook Design Co serves photographers by handling album and wall art design, communication, sales, and ordering for their clients.  Whether you\'re looking to offer clients albums for the first time, or trying to increase revenue from sales, SBDC will be a fantastic asset for your brand.',
      'Mention ShootWith.Me to get 25% off your onboarding fee.',
    ],
  },
];

export default partners;

export interface Partner {
  readonly name: string;
  readonly url: string;
  readonly imageUrl: string;
  readonly description: string | readonly string[];
  readonly couponCode?: string | null;
  readonly couponCodeDescription?: string | null;
}

partners.forEach(Object.freeze);
Object.freeze(partners);
